/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import "./MainContainer.scss";
import { connect } from "react-redux";

import Filter from "components/Filter/Filter";

import MoreSection from "components/MoreSection/MoreSection";

import NoticeList from "components/NoticeList/NoticeList";
// import { list } from "assets/data/list";
import MoreButton from "components/MoreButton/MoreButton";

import * as img from "../../assets/images/index";
import {
  reqNoticeList,
  reqChangeFilter,
  setCheckList,
} from "store/Notice/Notice.store";
import DetailContainer from "containers/DetailContainer/DetailContainer";

type Props = {
  noticeList: any;
  reqNoticeList: any;
  device: string;
  noticeCount: number;
  noticeTotal: number;
  reqChangeFilter: any;
  setCheckList: any;
  checkList: any;
  paging: any;
  match: any;
};

const MainContainer: React.FC<Props> = ({
  noticeList,
  reqNoticeList,
  device,
  noticeCount,
  noticeTotal,
  checkList,
  setCheckList,
  reqChangeFilter,
  paging,
  match,
}) => {
  const [isLoading, setLoading] = React.useState(false);
  const [id, setId] = React.useState(null);

  React.useEffect(() => {
    setId((window as any).location.href.split("?id=")[1]);
  }, [match]);
  const onClick = React.useCallback(
    (name: string) => {
      setCheckList(name);
    },
    [setCheckList]
  );

  React.useEffect(() => {
    if (
      !!device &&
      noticeList.length === 0 &&
      Object.keys(checkList).filter((item) => checkList[item] === false)
        .length === 0
    ) {
      reqNoticeList({
        poc: `${device !== "browser" ? `[${device}]` : ""}`,
      });
    }
  }, [noticeList]);

  const onSubmit = React.useCallback(() => {
    let array: any = [];
    Object.keys(checkList).map((item: any) => {
      if (checkList[item]) {
        return array.push(item);
      }
      return false;
    });

    reqChangeFilter({
      page: 1,
      poc: `${device !== "browser" ? `[${device}]` : ""}`,
      type: array,
    });
  }, [checkList, device, reqChangeFilter]);

  const onClickMore = () => {
    let array: any = [];
    Object.keys(checkList).map((item: any) => {
      if (checkList[item]) {
        return array.push(item);
      }

      return false;
    });
    setLoading(true);

    reqNoticeList({
      page: paging.currentPage + 1,
      poc: `${device !== "browser" ? `[${device}]` : ""}`,
      type: array,
    });
  };

  const onClickPopup = (e: any) => {
    e.preventDefault();
    window.open(
      "https://nateonweb.nate.com/helpdesk/notice/popup_list.php?BBSID=9",
      "notice_popup",
      "width=615, height=730, location=no, scrollbars=yes, toolbars=no, status=no"
    );
  };

  if (!id)
    return (
      <div className="MainContainer">
        <div className="sub-header">
          <h1>네이트온 공지사항</h1>
          {!!device && device === "browser" && (
            <p onClick={onClickPopup}>
              이전 공지사항 보기{" "}
              <img src={img.oldArrow} alt="arrow-icon" width="12" height="21" />
            </p>
          )}
        </div>
        <Filter
          checkList={checkList}
          setCheckList={setCheckList}
          onClick={onClick}
          onSubmit={onSubmit}
        />
        <MoreSection />
        {!!noticeList && (
          <NoticeList list={noticeList} setLoading={setLoading} />
        )}
        {!!paging && paging.currentPage * 10 < paging.totalListCount && (
          <MoreButton
            count={noticeCount}
            total={noticeTotal}
            onClick={onClickMore}
            isLoading={isLoading}
          />
        )}
        {/* {<MoreButton count={noticeCount} total={noticeTotal} />} */}
      </div>
    );
  else {
    return <DetailContainer id={id} />;
  }
};

export default connect(
  ({ Notice, Layout }: { Notice: any; Layout: any }) => ({
    noticeList: Notice.noticeList,
    noticeCount: Notice.noticeCount,
    noticeTotal: Notice.noticeTotal,
    device: Layout.device,
    paging: Notice.paging,
    checkList: Notice.checkList,
  }),
  {
    reqNoticeList,
    reqChangeFilter,
    setCheckList,
  }
)(MainContainer);
